export default __webpack_public_path__ + "static/media/podcast_1.33467d73.jpg";